import React from 'react'

import {PRIVACY_POLICY_URL} from '../../constants'
import {LegalPageView} from '../LegalPageView/LegalPageView'
import copy from './copy.json'

export const PrivacyPolicyView: React.FC<React.PropsWithChildren> = () => {
  return (
    <LegalPageView
      heading={copy.heading}
      intro={copy.intro}
      src={PRIVACY_POLICY_URL}
      iframeTitle={copy.iframeTitle}
    />
  )
}
